module.exports = __webpack_public_path__ + "static/img/02344_2.f868018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02344_2.jpg
// module id = o6BD
// module chunks = 1